"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const formatFaqCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$faqList = _ref.faqList,
    faqList = _ref$faqList === void 0 ? [] : _ref$faqList,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$tip = _ref.tip,
    tip = _ref$tip === void 0 ? {} : _ref$tip;
  const resultList = faqList.map((listItem, listIndex) => {
    const _listItem$title = listItem.title,
      title = _listItem$title === void 0 ? '' : _listItem$title,
      _listItem$list = listItem.list,
      list = _listItem$list === void 0 ? [] : _listItem$list;
    return {
      title,
      list
    };
  });
  let tipRes = {};
  if (Object.keys(tip).length > 0) {
    const img = tip.img,
      _tip$href = tip.href,
      href = _tip$href === void 0 ? '' : _tip$href,
      _tip$title = tip.title,
      title = _tip$title === void 0 ? '' : _tip$title,
      _tip$desc = tip.desc,
      desc = _tip$desc === void 0 ? '' : _tip$desc;
    tipRes = {
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      target: '_blank',
      extendProps: {
        'report-event': 'click_TpmFaq_tip_href',
        'report-ext1': href,
        'report-ext2': title
      },
      title,
      desc,
      href
    };
  }
  return {
    porintId,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    bg,
    data: resultList,
    tip: Object.keys(tipRes).length > 0 ? tipRes : undefined
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    console.log('faq-1-', data);
    const _formatFaqCommon = formatFaqCommon(data, {
        domains
      }),
      _formatFaqCommon$pori = _formatFaqCommon.porintId,
      porintId = _formatFaqCommon$pori === void 0 ? '' : _formatFaqCommon$pori,
      title = _formatFaqCommon.title,
      bg = _formatFaqCommon.bg,
      _formatFaqCommon$data = _formatFaqCommon.data,
      faqData = _formatFaqCommon$data === void 0 ? [] : _formatFaqCommon$data,
      _formatFaqCommon$tip = _formatFaqCommon.tip,
      tip = _formatFaqCommon$tip === void 0 ? {} : _formatFaqCommon$tip;
    console.log('faq--2', formatFaqCommon(data, {
      domains
    }));
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: "gems-materials-qci__newUI-faq"
    }, (0, _reportUtil.reportShow)(['show_newUI_FAQ', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.FAQ, {
      title: title,
      data: faqData,
      tip: tip,
      bg: bg
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}